import { AlertBar } from './AlertBar';

export default AlertBar;
